import { Component, input } from '@angular/core'
import { SpinnerComponent } from '@shared/components/spinner/spinner.component'
import { fadeIn, fadeOut } from '@shared/animations/animation'

@Component({
  animations: [fadeIn(500), fadeOut(100)],
  selector: 'app-offline',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './offline.component.html',
  styleUrl: './offline.component.scss',
})
export class OfflineComponent {
  online = input.required<boolean | undefined>()
}
